/// <reference types="@types/dom-navigation" />
import { LitElement, html, css, unsafeCSS } from 'lit';
import { map } from 'lit/directives/map.js';
import { ref, createRef } from 'lit/directives/ref.js';
import { customElement, state } from 'lit/decorators.js';
import styles from './styles.js';

import type { SelectionItem } from '../types/types.js';
import type { Ref } from 'lit/directives/ref.js';

/**
 *
 */
@customElement('selector-element')
export class BundidAntrag extends LitElement {
    static styles = [
        unsafeCSS(styles),
        css``,
    ];

    selectionItems : SelectionItem[] = [
        {
            name: 'Schlagloch melden',
            imageUrl: '/images/schlagloch.webp',
            applicationUrl: '/🕳',
        },
        {
            name: 'Einhornsteuer deklarieren',
            imageUrl: '/images/unicorn.webp',
            applicationUrl: '/🦄',
        },
        {
            name: 'Fernpiloten-Zeugnis beantragen',
            imageUrl: '/images/drone.webp',
            applicationUrl: '/🚁',
        },
        {
            name: 'Abmeldung aus Deutschland',
            imageUrl: '/images/tropical-island.webp',
            applicationUrl: '/🏝',
        },
    ];

    selectionItemRefs : Record<string, Ref<HTMLElement>> = this.initSelectionItemRefs(this.selectionItems);

    @state()
    currentSelectionItemIndex : number = 1;

    /**
     *
     */
    initSelectionItemRefs(selectionItems : SelectionItem[]) : Record<string, Ref<HTMLElement>> {
        const selectionItemRefs : Record<string, Ref<HTMLElement>> = {};
        selectionItems.forEach((selectionItem) => selectionItemRefs[selectionItem.name] = createRef());
        return selectionItemRefs;
    }

    /**
     *
     */
    selectionItemIndexDec(){
        if (this.currentSelectionItemIndex > 0){
            this.currentSelectionItemIndex--;
            // console.log('Decreased selection item index to ', this.currentSelectionItemIndex);
            this.scrollToItemIndex(this.currentSelectionItemIndex);
        } else console.warn('Tried to decrease selection item index at position 0.');
    }

    /**
     *
     */
    selectionItemIndexInc(){
        if (this.currentSelectionItemIndex < (this.selectionItems.length - 1)) {
            this.currentSelectionItemIndex++;
            // console.log('Increased selection item index to ', this.currentSelectionItemIndex);
            this.scrollToItemIndex(this.currentSelectionItemIndex);
        } else console.warn(`Tried to increase selection item index beyond max (${this.currentSelectionItemIndex}).`);
    }

    /**
     *
     */
    scrollToItemIndex(index : number) : void {
        const itemName = Object.keys(this.selectionItemRefs)[index];
        console.log('Scrolling to item ', itemName);
        this.selectionItemRefs[itemName]?.value?.scrollIntoView({ block: 'nearest', inline: 'center' });
    }

    scrollCarousel(event : WheelEvent) {
        event.preventDefault();
        if ((event.deltaY < 0) || (event.deltaX < 0)) this.selectionItemIndexDec();
        if ((event.deltaY > 0) || (event.deltaX > 0)) this.selectionItemIndexInc();
    }

    /**
     *
     */
    navigate(url : string, _event : PointerEvent){ window.navigation.navigate(url); }

    /**
     *
     */
    render() {
        return html`
            <div class="flex flex-col items-center justify-center">
                <div class="btn bg-base-100 mb-10 w-4/5">
                    <div class="prose prose-spreewunder">
                        <h3 class="text-center">Wählen Sie Ihren Antrag:</h3>
                    </div>
                </div>
                <div @wheel=${this.scrollCarousel} class="flex flex-col items-center justify-center relative">
                    <div class="carousel carousel-center w-4/5">
                        ${map(this.selectionItems, (selectionItem : SelectionItem) => html`
                            <div ${ref(this.selectionItemRefs[`${selectionItem.name}`])} id="item-${selectionItem.name}" class="carousel-item flex flex-col items-center w-1/3 relative">
                                <img
                                        src=${selectionItem.imageUrl}
                                        class="w-full rounded-field"
                                />
                                <button @click=${this.navigate.bind(this, selectionItem.applicationUrl)} class="btn btn-primary opacity-90 glass w-4/5 absolute bottom-1/8">${selectionItem.name}</button>
                            </div>
                        `)}
                    </div>
                    <div class="absolute left-10 right-10 top-1/2 flex -translate-y-1/2 transform justify-between">
                        <button class="btn btn-primary btn-circle glass ${this.currentSelectionItemIndex < 2 ? 'btn-disabled' : ''}" @click=${this.selectionItemIndexDec}>❮</button>
                        <button class="btn btn-primary btn-circle glass ${this.currentSelectionItemIndex > (this.selectionItems.length - 3) ? 'btn-disabled' : ''}" @click=${this.selectionItemIndexInc}>❯</button>
                    </div>
                </div>
            </div>
        `;
    }

}

declare global {
    interface HTMLElementTagNameMap {
        'selector-element' : BundidAntrag;
    }
}
